import React, { useContext, useEffect, useState, useRef } from "react";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
//import Stack from '@mui/material/Stack';
import axios from 'axios';
import moment from 'moment';
import api from '../../services/api';
import MenuItem from '@mui/material/MenuItem';
// LinkMui from '@mui/material/Link'; 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//import { Cookies } from 'react-cookie';
import { useNavigate, Link } from 'react-router-dom';
import InputMask from 'react-input-mask';
import Typography from "@mui/material/Typography";
import { BrowserView, MobileView } from 'react-device-detect';

function CadastroUsuario() {
    const numeroFocus = useRef(null);
    const [naoEditarDefinido, setNaoEditarDefinido] = useState(false);
    const [naoEditarFaturado, setNaoEditarFaturado] = useState(false);
    const [naoEditarNumeroReferenciaComplemento, setNaoEditarNumeroReferenciaComplemento] = useState(false);
    const [atualizarPagina, setAtualizarPagina] = useState(false);
    const [email, setEmail] = useState('');
    const [reEmail, setReEmail] = useState('');
    const [cpf_cnpj, setCpf_Cnpj] = useState('');
    const [labelCpf_Cnpj, setLabelCpf_Cnpj] = useState("CPF:");
    const [maskCpf_Cnpj, setMaskCpf_Cnpj] = useState("999.999.999-99"); 
    const [ie_rg, setIe_Rg] = useState('');
    const [razao_social, setRazao_Social] = useState('');
    const [cep, setCep] = useState('');
    const [iduf, setIduf] = useState(0);
    const [cidade, setCidade] = useState('');
    const [numero, setNumero] = useState('');
    const [rua, setRua] = useState('');
    const [bairro, setBairro] = useState('');
    const [complemento, setComplemento] = useState('');
    const [referencia, setReferencia] = useState('');
    const [listaDeEstados, setListaDeEstados] = useState([]);
    const [usuarioLogado, setUsuarioLogado] = useState("");  // Armazena Criptografado o Id e Loja do Cliente
    const [dadosCliente, setDadosCliente] = useState({});

    useEffect(() => {
    }, [atualizarPagina]);

    useEffect(() => {        
        let _ul = identificacaoUsuarioLogado();
        setUsuarioLogado(_ul);

console.log("CADAS A ", _ul);

        if (_ul != "")
        {
            obterDadosCliente(_ul);
           // https://localhost:5001/api/Clientes/ClienteInfo/1?idCliente=91&idLoja=1
        }        
        obterEstados();                
    }, []);
    

    const handleEmail = (e) => {
        setEmail(e.target.value);
    }

    const handleReEmail = (e) => {
        setReEmail(e.target.value);
    }

    const handleCpfCnpj = (e) => {
        setCpf_Cnpj(e.target.value);
    }

    const handleIe_Rg = (e) => {
        setIe_Rg(e.target.value);
    }

    const handleRazao_Social = (e) => {
        setRazao_Social(e.target.value);
    }

    const handleCep = (e) => {
        setCep(e.target.value);
        let novoCep = e.target.value.replace(' ', '').trim();
        if (novoCep.length === 9) {
            obterEnderecoViaCep(novoCep);
        }
    }

    const handleIduf = (e) => {
        setIduf(e.target.value);
    }

    const handleNumero = (e) => {
        setNumero(e.target.value);
    }
    const handleRua = (e) => {
        setRua(e.target.value);
    }
    const handleReferencia = (e) => {
        setReferencia(e.target.value);
    }
    const handleComplemento = (e) => {
        setComplemento(e.target.value);
    }
    const handleBairro = (e) => {
        setBairro(e.target.value);
    }
    const handleCidade = (e) => {
        setCidade(e.target.value);
    }

    function ValidarEmail(email) {
        const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regex.text(email);
    }

    function identificacaoUsuarioLogado(){
        if (sessionStorage.getItem("id_loja_usuario") == null || sessionStorage.getItem("id_loja_usuario") == ""){
           return "";        
        }
        return (Buffer.from( sessionStorage.getItem("id_loja_usuario").replace('YfhR7sFdS53a==','').substring(2) , 'base64').toString());
    }

    function obterDadosCliente(idCliente) {
        if (idCliente == null && ! idCliente.split('_').length !== 2)
        {
            
            return;
        }
        let _clie = idCliente.split('_');

        api.get(`Clientes/ClienteFullInfo/1?idCliente=${_clie[0]}&idLoja=${_clie[1]}`).then(response => {
            setDadosCliente(response?.data);
            setRazao_Social(response?.data?.clientes.razao_social);
            if (response?.data?.clientes?.cpf_cnpj.trim().length == 11)
            {
                setMaskCpf_Cnpj("999.999.999-99");
                setLabelCpf_Cnpj("CPF:");
                setNaoEditarFaturado(false);
                setNaoEditarNumeroReferenciaComplemento(false);
            }
            else
            {
                setMaskCpf_Cnpj("99.999.999/9999-99");
                setLabelCpf_Cnpj("CNPJ:");
                setNaoEditarFaturado(true);
                setNaoEditarNumeroReferenciaComplemento(true);
            }
            setCpf_Cnpj(response?.data?.clientes.cpf_cnpj);
            setIe_Rg(response?.data?.clientes.ie_rg);
            setBairro(response?.data?.enderecos[0].bairro);
            
        }).catch(erro => console.error(erro));
    }

    function obterEstados() {
        api.get('Estados').then(response => {
            const lista = response.data;
            lista.pop();
            const listaEstados = lista.map(estados => {
                return estados;
            });
            setListaDeEstados(listaEstados);
        }).catch(erro => console.error(erro));
    }

    function setNumeroFocus(){
        document.getElementById("numero").focus();
    }

    function obterEnderecoViaCep(_cepDG) {
        let __cep = _cepDG.replace('-', '').trim();
        apiCep.get(`${__cep}/json`).then(response => {
            const via = response?.data;
            if (via?.erro != undefined) {
                setNaoEditarDefinido(false);
                setNaoEditarNumeroReferenciaComplemento(false);
                setIduf(0);
                setCidade('');
                setRua('');
                setBairro('');
                setComplemento('');                
                erroCepNaoExiste(_cepDG);
                return;
            }

            if (via.ibge) {
                setIduf(via.ibge.trim().substring(0, 2))
            }
            if (via.localidade) {
                setCidade(via.localidade.trim().toUpperCase())
            }
            if (via.logradouro) {
                setRua(via.logradouro.trim().toUpperCase())
            }
            if (via.bairro) {
                setBairro(via.bairro.trim().toUpperCase())
            }
//            if (via.complemento) {
//                setComplemento(via.complemento.trim().toUpperCase())
//            }
            setNaoEditarDefinido(true);
            setNaoEditarNumeroReferenciaComplemento(false);
            setNumeroFocus();            

        }).catch(err => {
            erroCepNaoExiste(cep);
        });
    }

    let _clientes = {
        ids_clientes: 0,
        ids_loja: 0,
        razao_social: '',
        fantasia: '',
        cpf_cnpj: '',
        ie_rg: '',
        crt: 1,
        nao_cd: 0,
        disk: 0,
        faturado: 0,
        internet: 1,
        transportadora: 0,
        fornecedor: 0,
        funcionario: 0,
        limite_vendas: 0.00,
        ativo_clientes: 1,
        bloqueado: 0,
        buyonline: 0,
        cashonline: 0,
        filial: 0,
        buyfilial: 1,
        aid_luca: 0,
        senha_loja: '',
        senha_site: '',
        busca: '',
        filial_dias_repor: 0,
        limite_compras: 0.00,
        cd: 0,
        indfinal: 1,
        comprar: 0,
        hora_extra: 0.00,
        rg_orgao: 'DETRAN'
    };

    let _contatos = {
        ids_contatos: 0,
        ids_loja_contatos: 0,
        id_clientes_contatos: 0,
        id_loja_contatos: 0,
        apelido_cont: 'PADRÃO',
        nome: '',
        telefone: '',
        email: '',
        aniversario: moment(new Date()).format('YYYY-MM-DD'),
        padrao_contatos: 1,
        whatsapp: 0,
        senha_user: '',
        confirmado_email: 0,
        confirmado_telefone: 0
    };

    let _enderecos = {
        ids_enderecos: 0,
        ids_loja_enderecos: 0,
        id_clientes_enderecos: 0,
        id_loja_enderecos: 0,
        bacen: 1058,
        apelido_endereco: 'PADRÃO',
        rua: '',
        numero: '',
        complemento: '',
        bairro: '',
        iduf: 0,
        idcidade: 0,
        cep: '',
        referencia: '',
        padrao_enderecos: 1,
        ativo_endereco: 1,
        ext_uf: '',
        ext_cidade: '',
        latitude: '',
        longitude: ''
    };

    const [usuariosWebClass, setUsuariosWebClass] = useState({
        clientes: _clientes,
        contatos: _contatos,
        enderecos: _enderecos,
        cidade: '',
        senhaRepete: '',
        date: moment(new Date()).format('YYYY-MM-DD'),
        validacao: false
    });

    const dados = usuariosWebClass;

    const apiCep = axios.create({
        baseURL: "https://viacep.com.br/ws/"
    });


    const erroEmail = () => toast.error("Por Favor, Use um E-Mail Válido!",
        { position: toast.POSITION.TOP_CENTER, theme: "colored" });

    const erroSenha = () => toast.error("As Senhas Estão Diferentes!",
        { position: toast.POSITION.TOP_CENTER, theme: "colored" });

    const erroSenhaDigitada = () => toast.error("Senhas Deverão Possuir Pelo Menos 6 Dígitos!",
        { position: toast.POSITION.TOP_CENTER, theme: "colored" });

    const erroNome = () => toast.error("Nome é um Campo Obrigatório!",
        { position: toast.POSITION.TOP_CENTER, theme: "colored" });

    const erroCpf = () => toast.error("O CPF Digitado Está Inválido!",
        { position: toast.POSITION.TOP_CENTER, theme: "colored" });

    const erroTelefone = () => toast.error("O Telefone é um Campo Obrigatório!",
        { position: toast.POSITION.TOP_CENTER, theme: "colored" });

    const erroData = () => toast.error("Verifique a Data de Nascimento!",
        { position: toast.POSITION.TOP_CENTER, theme: "colored" });

    const erroCepNaoExiste = (cep) => toast.error(`O CEP ${cep} Não Foi Localizado!`,
        { position: toast.POSITION.TOP_CENTER, theme: "colored" });

    const erroCep = () => toast.error("Informe o Seu CEP!",
        { position: toast.POSITION.TOP_CENTER, theme: "colored" });

    const erroRua = () => toast.error("O Campo Rua é Obrigatório!",
        { position: toast.POSITION.TOP_CENTER, theme: "colored" });

    const erroBairro = () => toast.error("Informe o Bairro!",
        { position: toast.POSITION.TOP_CENTER, theme: "colored" });

    const erroNumero = () => toast.error("Informe o Número da Sua Residência!",
        { position: toast.POSITION.TOP_CENTER, theme: "colored" });

    const erroEstado = () => toast.error("Selecione o seu Estado UF!",
        { position: toast.POSITION.TOP_CENTER, theme: "colored" });

    const erroCidade = () => toast.error("Selecione a Sua Cidade!",
        { position: toast.POSITION.TOP_CENTER, theme: "colored" });

  console.log("TESTUPF ", naoEditarDefinido);
  console.log("TESTUPJ ", naoEditarFaturado);        

  return (
    <>
    <BrowserView>
    <Grid container justifyContent={"center"} spacing={1} paddingLeft={'10px'}>
        <Grid item xs={12} marginTop={'15px'}>
            <Typography variant='h4' xs={{ marginBottom: '20px' }}>
                Crie a Sua Conta na NAFIL Auto Peças
            </Typography>
            <Typography variant='h11' xs={{ marginBottom: '20px' }} style={{ color: 'red', fontWeight: 'bold' }}>
                Onde Você Encontra Tudo Para Seu Veículo com Duas ou Quatro Rodas
            </Typography>
        </Grid>
        <Grid item xs={12}>
            <Typography sx={{ textAlign: "center", fontFamily: "roboto" }} variant="h7" component="div" gutterBottom>
                Ja tenho minha conta, vou <Link to="/login"> Entrar </Link>
            </Typography>
        </Grid>
        <Grid item xs={12} textAlign={'left'} marginLeft={'12px'}>
            <Typography variant='h11' xs={{ marginBottom: '4px' }}>
                Meus Dados Pessoais:
            </Typography>
        </Grid>
        <Grid item xs={6}>
            <TextField
                fullWidth
                id="Email"
                value={email}
                onChange={(event) => {
                    handleEmail(event);
                }}
                autoFocus
                label="E-mail:"
                variant="outlined"
                required
            />
        </Grid>
        <Grid item xs={6} paddingRight={'10px'}>
            <TextField
                fullWidth
                id="re_email"
                value={reEmail}
                onChange={(event) => {
                    handleReEmail(event);
                }}
                label="Confirme Seu E-mail:"
                variant="outlined"
                required
            />
        </Grid>

        <Grid item xs={3}>
            <InputMask mask={maskCpf_Cnpj} maskPlaceholder=" " value={cpf_cnpj}
                InputProps={{readOnly: naoEditarFaturado }}
                onChange={(event) => {
                    handleCpfCnpj(event)
                }}>
                <TextField
                    fullWidth
                    id="cpf_cnpj"
                    required
                    label={labelCpf_Cnpj}
                    variant="outlined">
                </TextField>
            </InputMask>
        </Grid>

        <Grid item xs={3}>
            <TextField
                fullWidth
                id="Ie_Rg"
                value={ie_rg}
                InputProps={{readOnly: naoEditarFaturado }}
                onChange={(event) => { handleIe_Rg(event) }}
                // required
                label="Identidade:"
                variant="outlined">
            </TextField>
        </Grid>

        <Grid item xs={6} paddingRight={'10px'}>
            <TextField
                fullWidth
                id="Nome"
                label="Nome Completo:"
                value={razao_social}
                onChange={(event) => { handleRazao_Social(event) }}
                InputProps={{readOnly: naoEditarFaturado }}
                required
            />
        </Grid>

        <Grid item xs={12} textAlign={'left'} marginLeft={'12px'}>
            <Typography variant='h11' xs={{ marginBottom: '4px' }}>
                Meu Endereço:
            </Typography>
        </Grid>

        <Grid item xs={1.5}>
            <InputMask mask="99999-999" maskPlaceholder=" " value={cep}
                onChange={(event) => { handleCep(event) }}>
                <TextField
                    fullWidth
                    id="cep"
                    required
                    label="CEP:"
                    variant="outlined"
                    InputProps={{readOnly: naoEditarFaturado }}>
                </TextField>
            </InputMask>
        </Grid>

        <Grid item xs={2.5}>
            <TextField
                fullWidth
                select
                label="Estados"
                required
                InputProps={{readOnly: (naoEditarDefinido === true || naoEditarFaturado === true) }}
                value={iduf}
                onChange={(event) => { handleIduf(event) }}>
                {listaDeEstados.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                        {option.uf}
                    </MenuItem>
                ))}
            </TextField>
        </Grid>

        <Grid item xs={3}>
            <TextField
                fullWidth
                id="cidade"
                value={cidade}
                InputProps={{readOnly: (naoEditarDefinido === true || naoEditarFaturado === true) }}
                onChange={(event) => handleCidade(event)}
                label="Cidade"
                variant="outlined">
            </TextField>
        </Grid>

        <Grid item xs={5} paddingRight={'10px'}>
            <TextField
                fullWidth
                id="rua"
                value={rua}
                InputProps={{readOnly: (naoEditarDefinido === true || naoEditarFaturado === true) }}
                onChange={(event) => { handleRua(event) }}
                label="Endereço"
                variant="outlined"
                required>
            </TextField>
        </Grid>

        <Grid item xs={1.5}>
            <TextField
                fullWidth
                id="numero"
                value={numero}
                InputProps={{readOnly: (naoEditarNumeroReferenciaComplemento === true) }}
                onChange={(event) => { handleNumero(event) }}                
                label="Número"
                variant="outlined"
                ref={numeroFocus}
                required>
            </TextField>
        </Grid>

        <Grid item xs={2.5}>
            <TextField
                fullWidth
                id="bairro"
                value={bairro}
                InputProps={{readOnly: (naoEditarDefinido === true || naoEditarFaturado === true) }}
                onChange={(event) => { handleBairro(event) }}
                label="Bairro"
                variant="outlined"
                required>
            </TextField>
        </Grid>

        <Grid item xs={4}>
            <TextField
                fullWidth
                id="complemento"
                value={complemento}
                InputProps={{readOnly: (naoEditarNumeroReferenciaComplemento === true) }}
                onChange={(event) => { handleComplemento(event) }}
                label="Complemento"
                variant="outlined">
            </TextField>
        </Grid>

        <Grid item xs={4} paddingRight={'10px'}>
            <TextField
                fullWidth
                id="referencia"
                value={referencia}
                InputProps={{readOnly: (naoEditarNumeroReferenciaComplemento === true) }}
                onChange={(event) => { handleReferencia(event) }}
                label="Referência"
                variant="outlined">
            </TextField>
        </Grid>

        <Grid item xs={2.5} paddingLeft={'10px'} marginBottom={'20px'} >
            <InputMask mask="(99) 9999-9999" maskPlaceholder=" ">
                <TextField
                    fullWidth
                    id="telefoneFixo"
                    // value={this.state.cliente.CpfCnpj}
                    // onChange={e => this.handleCliente(e)}
                    // required
                    label="Telefone Fixo:"
                    variant="outlined">
                </TextField>
            </InputMask>            
        </Grid>               
        <Grid item xs={2.5}>
            <InputMask mask="(99) 99999-9999" maskPlaceholder=" ">
                <TextField
                    fullWidth
                    id="telefoneCelular"
                    // value={this.state.cliente.CpfCnpj}
                    // onChange={e => this.handleCliente(e)}
                    required
                    label="Telefone Celular:"
                    variant="outlined">
                </TextField>
            </InputMask>
        </Grid>

        <Grid item xs={2.45} marginBottom={'45px'}>
            <TextField
                fullWidth
                id="SenhaSite"
                // value={this.state.cliente.SenhaSite}
                // onChange={e => this.handleCliente(e)}
                label="Digite Uma Senha:"
                type="password"
                required
            />
        </Grid>
        <Grid item xs={2.4}>
            <TextField
                fullWidth
                id="ReSenhaSite"
                // value={this.state.cliente.SenhaSite}
                // onChange={e => this.handleCliente(e)}
                label="Repita a Senha:"
                type="password"
                required
            />
        </Grid>

        <Grid item xs={1}>
            <Button onClick={e => this.handleSubmit(e)} variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '35px', width: '110px', marginTop: '11px' }}>Salvar</Button>
        </Grid>
        <Grid item xs={1} marginLeft={'5px'} marginRight={'10px'}>
            <Button onClick={"() => UtilizarCreditoDigitado()"} variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '35px', marginTop: '11px' }}>Cancelar</Button>
        </Grid>
    </Grid>
    </BrowserView>

    <MobileView>
    <Grid container justifyContent={"center"} spacing={1} paddingLeft={'10px'}>
        <Grid item xs={12} marginTop={'15px'}>
            <Typography variant='h4' xs={{ marginBottom: '20px' }}>
                Crie a Sua Conta na NAFIL Auto Peças
            </Typography>
            <Typography variant='h11' xs={{ marginBottom: '20px' }} style={{ color: 'red', fontWeight: 'bold' }}>
                Onde Você Encontra Tudo Para Seu Veículo com Duas ou Quatro Rodas
            </Typography>
        </Grid>
        <Grid item xs={12}>
            <Typography sx={{ textAlign: "center", fontFamily: "roboto" }} variant="h7" component="div" gutterBottom>
                Ja tenho minha conta, vou <Link to="/login"> Entrar </Link>
            </Typography>
        </Grid>
        <Grid item xs={12} textAlign={'left'} marginLeft={'12px'}>
            <Typography variant='h11' xs={{ marginBottom: '4px' }}>
                Meus Dados Pessoais:
            </Typography>
        </Grid>
        <Grid item xs={12} paddingRight={'10px'}>
            <TextField
                fullWidth
                id="Email"
                value={email}                
                onChange={(event) => {
                    handleEmail(event);
                }}
                autoFocus
                label="E-mail:"
                variant="outlined"
                required
            />
        </Grid>
        <Grid item xs={12} paddingRight={'10px'}>
            <TextField
                fullWidth
                id="re_email"
                value={reEmail}
                onChange={(event) => {
                    handleReEmail(event);
                }}
                label="Confirme Seu E-mail:"
                variant="outlined"
                required
            />
        </Grid>

        <Grid item xs={12} paddingRight={'10px'}>
            <InputMask mask={maskCpf_Cnpj} 
                maskPlaceholder=" " 
                value={cpf_cnpj}
                InputProps={{readOnly: naoEditarFaturado }}
                onChange={(event) => {
                    handleCpfCnpj(event)
                }}>
                <TextField
                    fullWidth
                    id="cpf_cnpj"
                    required
                    label={labelCpf_Cnpj}
                    variant="outlined">
                </TextField>
            </InputMask>
        </Grid>

        <Grid item xs={12} paddingRight={'10px'}>
            <TextField
                fullWidth
                id="Ie_Rg"
                value={ie_rg}
                InputProps={{readOnly: naoEditarFaturado }}
                onChange={(event) => { handleIe_Rg(event) }}
                // required
                label="Identidade:"
                variant="outlined">
            </TextField>
        </Grid>

        <Grid item xs={12} paddingRight={'10px'}>
            <TextField
                fullWidth                
                id="Nome"                
                label="Nome Completo:"
                value={razao_social}
                onChange={(event) => { handleRazao_Social(event) }}
                InputProps={{readOnly: naoEditarFaturado }}
                required
            />
        </Grid>

        <Grid item xs={12} textAlign={'left'} marginLeft={'12px'}>
            <Typography variant='h11' xs={{ marginBottom: '4px' }}>
                Meu Endereço:
            </Typography>
        </Grid>

        <Grid item xs={12} paddingRight={'10px'}>
            <InputMask 
                mask="99999-999" 
                maskPlaceholder=" " value={cep}
                onChange={(event) => { handleCep(event) }}>
                <TextField
                    fullWidth
                    id="cep"
                    required
                    label="CEP:"
                    variant="outlined"
                    InputProps={{readOnly: naoEditarFaturado }}>
                </TextField>
            </InputMask>
        </Grid>

        <Grid item xs={12} paddingRight={'10px'}>
            <TextField                
                fullWidth
                select
                label="Estados"
                required
                InputProps={{readOnly: (naoEditarDefinido === true || naoEditarFaturado === true) }}
                value={iduf}
                onChange={(event) => { handleIduf(event) }}>
                {listaDeEstados.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                        {option.uf}
                    </MenuItem>
                ))}
            </TextField>
        </Grid>

        <Grid item xs={12} paddingRight={'10px'}>
            <TextField
                fullWidth
                id="cidade"
                value={cidade}                
                InputProps={{readOnly: (naoEditarDefinido === true || naoEditarFaturado === true) }}
                onChange={(event) => handleCidade(event)}
                label="Cidade"
                variant="outlined">
            </TextField>
        </Grid>

        <Grid item xs={12} paddingRight={'10px'}>
            <TextField
                fullWidth
                id="rua"
                paddingRight={'10px'}
                value={rua}
                InputProps={{readOnly: (naoEditarDefinido === true || naoEditarFaturado === true) }}
                onChange={(event) => { handleRua(event) }}
                label="Endereço"
                variant="outlined"
                required>
            </TextField>
        </Grid>

        <Grid item xs={12} paddingRight={'10px'}>
            <TextField
                fullWidth
                id="numero"
                value={numero}
                InputProps={{readOnly: (naoEditarNumeroReferenciaComplemento === true) }}
                onChange={(event) => { handleNumero(event) }}
                label="Número"
                variant="outlined"
                ref={numeroFocus}
                required>
            </TextField>
        </Grid>

        <Grid item xs={12} paddingRight={'10px'}>
            <TextField
                fullWidth
                id="bairro"                
                value={bairro}
                InputProps={{readOnly: (naoEditarDefinido === true || naoEditarFaturado === true) }}
                onChange={(event) => { handleBairro(event) }}
                label="Bairro"
                variant="outlined"
                required>
            </TextField>
        </Grid>

        <Grid item xs={12} paddingRight={'10px'}>
            <TextField
                fullWidth
                id="complemento"                
                value={complemento}
                InputProps={{readOnly: (naoEditarNumeroReferenciaComplemento === true) }}
                onChange={(event) => { handleComplemento(event) }}
                label="Complemento"
                variant="outlined">
            </TextField>
        </Grid>

        <Grid item xs={12} paddingRight={'10px'}>
            <TextField
                fullWidth
                id="referencia"                
                value={referencia}
                InputProps={{readOnly: (naoEditarNumeroReferenciaComplemento === true) }}
                onChange={(event) => { handleReferencia(event) }}
                label="Referência"
                variant="outlined">
            </TextField>
        </Grid>

        <Grid item xs={12} paddingRight={'10px'}>
            <InputMask mask="(99) 9999-9999" maskPlaceholder=" ">
                <TextField
                    fullWidth
                    id="telefoneFixo"                    
                    // value={this.state.cliente.CpfCnpj}
                    // onChange={e => this.handleCliente(e)}
                    // required
                    label="Telefone Fixo:"
                    variant="outlined">
                </TextField>
            </InputMask>            
        </Grid>               
        <Grid item xs={12} paddingRight={'10px'}>
            <InputMask mask="(99) 99999-9999" maskPlaceholder=" ">
                <TextField
                    fullWidth
                    id="telefoneCelular"                    
                    // value={this.state.cliente.CpfCnpj}
                    // onChange={e => this.handleCliente(e)}
                    required
                    label="Telefone Celular:"
                    variant="outlined">
                </TextField>
            </InputMask>
        </Grid>

        <Grid item xs={12} paddingRight={'10px'}>
            <TextField
                fullWidth
                id="SenhaSite"                
                // value={this.state.cliente.SenhaSite}
                // onChange={e => this.handleCliente(e)}
                label="Digite Uma Senha:"
                type="password"
                required
            />
        </Grid>
        <Grid item xs={12} paddingRight={'10px'}>
            <TextField
                fullWidth
                id="ReSenhaSite"                
                // value={this.state.cliente.SenhaSite}
                // onChange={e => this.handleCliente(e)}
                label="Repita a Senha:"
                type="password"
                required
            />
        </Grid>

        <Grid item xs={6}>
            <Button onClick={"() => UtilizarCreditoDigitado()"} variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '35px', marginTop: '11px' }}>Cancelar</Button>
        </Grid>
        <Grid item xs={6} marginBottom={'15px'}>
            <Button onClick={e => this.handleSubmit(e)} variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '35px', width: '110px', marginTop: '11px' }}>Salvar</Button>
        </Grid>

    </Grid>
    </MobileView>

    <ToastContainer/>
    </>
  )
}

export default CadastroUsuario